import {
  MotifActionIcDashboard24px,
  // IconoirPage,
  IconoirFolder,
  MotifHardwareIcSecurity24px,
  IconoirPrivacyPolicy,
  // MotifActionIcHelp24px,
  // MotifSocialIcPerson24px,
  // MotifActionIcSettings24px,
} from "@ey-xd/motif-icon";

import { MotifIcon } from "@ey-xd/motif-react";

export interface MenuDataItem {
  label: string;
  path: string;
  icon?: JSX.Element;
  selected?: boolean;
  subMenus?: MenuDataItem[];
}

export enum ActiveTabsOrder {
  SUMMARY = 0,
  CREDITOR = 1,
  CLAIM = 2,
  VOTING = 3,
  DISTRIBUTION = 4,
  PAYMENT = 5,
  CONFIGURATION = 6,
  DEBTOR = 7,
  REPORTING = 8,
  IMPORT = 9,
  TASK = 10,
  PORTAL = 11,
  SUBMISSIONMANAGEMENT = 12,
}

const menuData = [
  {
    label: "pages.navBar.moduleDetails.homeLabel",
    path: "/",
    icon: <MotifIcon src={MotifActionIcDashboard24px} />,
  },
  {
    label: "pages.navBar.moduleDetails.caseLabel",
    path: `/case`,
    icon: <MotifIcon src={IconoirFolder} />,
    // @ts-ignore
    subMenus: [
      {
        label: "pages.navBar.moduleDetails.caseSubModuleDetails.summaryLabel",
        path: `?activeTab=${ActiveTabsOrder.SUMMARY}`,
        matchPath: ["/summary/"],
      },
      {
        label: "pages.navBar.moduleDetails.caseSubModuleDetails.creditorLabel",
        path: `?activeTab=${ActiveTabsOrder.CREDITOR}`,
        matchPath: ["/creditor/"],
      },
      {
        label: "pages.navBar.moduleDetails.caseSubModuleDetails.claimLabel",
        path: `?activeTab=${ActiveTabsOrder.CLAIM}`,
        matchPath: ["/claim/"],
      },
      {
        label: "pages.navBar.moduleDetails.caseSubModuleDetails.votingLabel",
        path: `?activeTab=${ActiveTabsOrder.VOTING}`,
        matchPath: ["/voting/"],
      },

      {
        label:
          "pages.navBar.moduleDetails.caseSubModuleDetails.distributionLabel",
        path: `?activeTab=${ActiveTabsOrder.DISTRIBUTION}`,
        matchPath: [
          "/distribution/",
          "/manual-data-source-edit/",
          "/duplicate-distribution/create/",
        ],
      },
      {
        label: "pages.navBar.moduleDetails.caseSubModuleDetails.paymentLabel",
        path: `?activeTab=${ActiveTabsOrder.PAYMENT}`,
        matchPath: ["/payment/"],
      },
      {
        label:
          "pages.navBar.moduleDetails.caseSubModuleDetails.configurationLabel",
        path: `?activeTab=${ActiveTabsOrder.CONFIGURATION}`,
        matchPath: ["/configuration/", "scheme-manage/"],
      },
      {
        label: "pages.navBar.moduleDetails.caseSubModuleDetails.debtorLabel",
        path: `?activeTab=${ActiveTabsOrder.DEBTOR}`,
        matchPath: ["/debtor/"],
      },
      {
        label: "pages.navBar.moduleDetails.caseSubModuleDetails.reportingLabel",
        path: `?activeTab=${ActiveTabsOrder.REPORTING}`,
        matchPath: ["/reporting/"],
      },
      {
        label: "pages.navBar.moduleDetails.caseSubModuleDetails.importLabel",
        path: `?activeTab=${ActiveTabsOrder.IMPORT}`,
        matchPath: ["/import/"],
      },
      {
        label: "pages.navBar.moduleDetails.caseSubModuleDetails.taskLabel",
        path: `?activeTab=${ActiveTabsOrder.TASK}`,
        matchPath: ["/tasks/"],
      },
      // {
      //   label: "pages.navBar.moduleDetails.caseSubModuleDetails.portalLabel",
      //   path: `?activeTab=${ActiveTabsOrder.PORTAL}`,
      //   matchPath: ["/form/"],
      // },
      // {
      //   label: "pages.navBar.moduleDetails.caseSubModuleDetails.submissionManagementLabel",
      //   path: `?activeTab=${ActiveTabsOrder.SUBMISSIONMANAGEMENT}`,
      //   matchPath: ["/SubmissionManagement/"],
      // },
    ],
  },
  {
    label: "pages.navBar.moduleDetails.userManagementLabel",
    path: "/user-management",
    icon: <MotifIcon src={MotifHardwareIcSecurity24px} />,
  },
  {
    label: "pages.navBar.moduleDetails.privacyNoticeLabel",
    path: "https://eycanada.sharepoint.com/:b:/s/ClaimsManagementSystem-CMSPhase1-LearningMaterials/EdvYSQaAzRpNmIDGr7l3gvABWTAF-UQ0FUE6XLrtOKQxcg?e=EKcKnI",
    icon: <MotifIcon src={IconoirPrivacyPolicy} />,
  },
  // {
  //   label: "My Profile",
  //   path: "/my-profile",
  //   icon: <MotifIcon src={MotifSocialIcPerson24px} />,
  // },
  // {
  //   label: "System Settings",
  //   path: "/system-settings",
  //   icon: <MotifIcon src={MotifActionIcSettings24px} />,
  // },
  // {
  //   label: "Help & Support",
  //   path: "/help-support",
  //   icon: <MotifIcon src={MotifActionIcHelp24px} />,
  // },
];

export default menuData;
